import "./Header.css";

export default function Header({ onLogout }) {
  return (
    <header className="header">
      
      {/* 🔥 Logo en lugar del texto */}
      <img 
        src="/logo_encabezado_sin_fondo.png" 
        alt="Logo Institucional" 
        className="header-logo"
      />

      <button className="logout-btn" onClick={onLogout}>
        Cerrar sesión
      </button>
    </header>
  );
}
